import clsx from 'clsx'
// import useSWR, { useSWRConfig } from 'swr'
import React from 'react'
import { getLanguage } from '@futures-platform/i18n'
import { Modal, paddingModalStyles } from '@futures-platform/ui'
import { finalTranslations } from '../../localTranslation'
import styles from './DeleteConfirmationModal.module.css'

const DeleteConfirmationModal = ({
  isDeleteModalOpened,
  deleteModalOpenedHandler,
  handleCloseDeleteConfirmation,
}) => {
  const handleYesRemoveCmtBtn = () => {
    deleteModalOpenedHandler()
  }

  return (
    <Modal
      onRequestClose={handleCloseDeleteConfirmation}
      isOpen={isDeleteModalOpened}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={paddingModalStyles}>
      <div className={clsx(styles.modalWrapper, 'confirmation-modal-content')}>
        <h3 className={clsx(styles.h3Title, 'confirmation-modal-title')}>
          Are you sure to remove this scenario?
        </h3>
        <div className={clsx(styles.pb_39, 'confirmation-modal-actions')}>
          <button
            onClick={handleCloseDeleteConfirmation}
            className="btn btn-lg btn-plain-gray">
            CANCEL
          </button>
          <button
            onClick={handleYesRemoveCmtBtn}
            className="btn btn-lg btn-primary"
            // onClick={deletePublicLink}
          >
            {getLanguage() === 'fi'
              ? finalTranslations?.removeCommentYesOption?.fi
              : finalTranslations?.removeCommentYesOption?.en}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteConfirmationModal
